import TSXComponent from '@/utils/tsx-component';
import { ActionBar, Bottom, Button, Dialog, Form, NavBar, NoticeBar, Popup, Toast } from '@ohu-mobile/core';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { AdvertModule } from '@/store/modules/advert';
import FormItem from '@/components/form-item';
import SubjectSelect from '@/components/select/subject-select';
import RankSelect from '@/components/select/rank-select/RankSelect';
import type { SetTrinityScoreBody } from 'server-api';
import { setTrinityScore } from '@/api';
import { wrapApi } from '@/utils/wrap-api';
import { userModule } from '@/store/modules/user';
import { CloseOutlined } from '@ohu-mobile/icons';
import { getSaveTip } from '@/utils/getSaveTip';

import './transcript.scss';


export type TrinityTranscriptModel = SetTrinityScoreBody;

export interface TranscriptProps {
  visible?: boolean;
  initValues?: TrinityTranscriptModel,
}

export interface TranscriptEvents {
  onVisibleChange: boolean;
  onSuccess: void;
}


@Component({ name: 'trinity-transcript' })
export class Transcript extends TSXComponent<TranscriptProps, TranscriptEvents> {
  @Prop({ type: Boolean, default: false })
  visible!: boolean;

  @Prop()
  initValues!: TrinityTranscriptModel;

  get isInitValuesEmpty() {
    if (!this.initValues) return true;
    return !this.initValues.optionalSubject?.length && !this.initValues.subjectGrade?.length;
  }

  internalVisible = this.visible;
  @Watch('visible')
  onVisibleChange(visible: boolean) {
    this.internalVisible = visible;
    if (this.internalVisible) {
      userModule.getTrinityInfo(true);
    }
  }

  loading = false;

  async save(body: TrinityTranscriptModel) {
    const res = await wrapApi(
      () => setTrinityScore(body),
      (sending) => (this.loading = sending),
      { errorTip: 'alert', loadingTip: ['正在保存'] },
    );
    if (res.success) {
      await userModule.getTrinityInfo(true);
      this.$emit('visibleChange', false);
      this.$emit('success');
    }
  }

  get saveTip() {
    const trinityInfo = userModule.trinityInfo;
    return getSaveTip(trinityInfo, '当前不允许保存三位一体成绩单');
  }



  submit(values: TrinityTranscriptModel) {
    Dialog.confirm({
      title: '须知',
      render: () => <div class="article-tip" domPropsInnerHTML={this.editScoreTip}></div>,
      onOk: () => {
        this.save(values);
      },
    });
  }

  editScoreTip = '每位用户可保存二次成绩，请填写准确的选考科目和学考等第。请仔细核对，如有错误请修改后再保存。避免浪费保存次数';

  async loadTips() {
    const r1 = await wrapApi(
      () => AdvertModule.getAdvert({
        platformCode: '手机',
        showAreaCode: 'C111',
        areaCode: '浙江',
        moduleCode: '三位一体',
      }),
      () => {},
    );
    if (r1.success && r1.result[0]?.text1) {
      this.editScoreTip = r1.result[0].text1;
    }
  }

  created() {
    this.loadTips();
  }

  render() {
    return (
      <Popup
        visible={this.visible}
        onVisibleChange={(visible) => {
          this.$emit('visibleChange', visible);
        }}
        mask={false}
        position="bottom"
        targetClass="transcript-wrapper"
      >
        <NavBar
          divider
          title={this.isInitValuesEmpty ? '请先填写三位一体成绩单' : '修改三位一体成绩单'}
        >
          <Button slot="right" round type="link" inline icon={CloseOutlined} onClick={() => {
            this.$emit('visibleChange', false);
          }}></Button>
        </NavBar>
        <div class="transcript">
          {this.saveTip && <NoticeBar multiline text={this.saveTip} />}
          <Form
            inline={false}
            initialValues={this.initValues}
            scrollToError
            validateSchema={(yup) => ({
              optionalSubject: yup.array().min(3, '请选择三个选考科目').max(3),
              subjectGrade: yup.array().min(10, '请选择学科等第').max(10),
            })}
            onSubmit={this.submit}
            scopedSlots={{
              default: () => (
                <div>
                  <FormItem title="学考科目等第" required>
                    <Form.Field name="subjectGrade" padding={false}>
                      <RankSelect />
                    </Form.Field>
                  </FormItem>
                  <FormItem title="选考科目" required>
                    <Form.Field name="optionalSubject">
                      <SubjectSelect />
                    </Form.Field>
                  </FormItem>
                  <Bottom>
                    <ActionBar
                      actions={[
                        { text: '保 存', type: 'primary', htmlType: 'submit' },
                      ]} />
                  </Bottom>
                </div>
              ),
            }}>
          </Form>
        </div>
      </Popup>
    );
  }
}
